import { Component, Prop, State, Element, h, Method, Listen } from '@stencil/core';
import { DropDownDirection } from './types';

@Component({
  tag: 'zpr-dropdown-menu'
})

export class ZprDropdownMenu {
  private _dropdown:HTMLZprDropdownElement;

  @Element() el: HTMLElement;
  @Prop() parent: HTMLElement | string;
  @Prop({reflect: true}) direction: DropDownDirection
  @Prop({reflect: true}) size:string;

  @State() _direction: DropDownDirection;

  componentWillLoad(){
    this._direction = this.direction;
  }

  determineOpenDirection(){
    const totalOptions = this.el.querySelectorAll('[slot="body"] li').length;
    const hasParent = this.parent ? true : false;

    if(!hasParent) return;

    const parentEl = (typeof this.parent == 'string' ? document.querySelector(this.parent) : this.parent) as HTMLElement;
    const dropdownHeight = totalOptions * 40 + 16 + 8 // total li options * 40px height each + 16 padding panel + 8px off from the menu
    const parentPosition = parentEl.getBoundingClientRect();
    const menuPosition = this.el.getBoundingClientRect();

    const toLeft = menuPosition.left - 208 > parentPosition.left && menuPosition.left - 208 < parentPosition.right;
    const toRight = menuPosition.right + 208 < parentPosition.right;
    const baseBottom = menuPosition.top + dropdownHeight < parentPosition.bottom;
    const fromTop = menuPosition.top - dropdownHeight > parentPosition.top;
    const fromBottom = menuPosition.bottom + dropdownHeight < parentPosition.bottom;
    const up = menuPosition.bottom - dropdownHeight > parentPosition.top;

    const directions = {
      'bottom-left':  fromBottom && toLeft,
      'left-up':      up && toLeft,
      'left-bottom':  baseBottom && toLeft,
      'top-left':     fromTop && toLeft,
      'right-up':     up && toRight,
      'right-bottom': baseBottom && toRight,
      'bottom-right': fromBottom && toRight,
      'top-right':    fromTop && toRight,
    }
    const direction = Object.keys(directions).find((directionKey)=> directions[directionKey] == true);
    this._direction = direction as DropDownDirection;
  }

  componentDidLoad(){
   this.determineOpenDirection()
  }

  @Method()
  async open(){
    this._dropdown.open();
  }

  @Method()
  async close(){
    this._dropdown.close();
  }

  render() {
    return (
      <zpr-dropdown direction={this._direction} size={this.size} ref={ el => this._dropdown = el }>
        <slot name="toggle"/>
        <slot name="body"/>
      </zpr-dropdown>
    )
  }
}